import { RootState } from 'store/root-reducer';

// import { ValidationRule } from './types';

export const getValidationRules = (state: RootState): any[] | null => state.admin.validationRules.entities; // ValidationRule[]

export const isValidationRulesLoading = (state: RootState): boolean => state.admin.validationRules.isLoading;

export const isCreateValidationRuleLoading = (state: RootState): boolean => state.admin.validationRules.isCreateLoading;

export const isUpdateValidationRuleLoading = (state: RootState): boolean => state.admin.validationRules.isUpdateLoading;

export const isDeleteValidationRuleLoading = (state: RootState): boolean => state.admin.validationRules.isDeleteLoading;
